import { Stack, Typography, Avatar } from "@mui/material";
import profilePicture from "../../../../assets/icons/Profile_Picture.png";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLocale } from "../../../../locales/localeSlice";

const Feature1Box = () => {
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);
  return (
    <Stack justifyContent={"center"} alignItems={"center"} paddingTop={6}>
      <Typography
        fontSize={{ md: "18px", sm: "16px", xs: "14px" }}
        fontWeight={700}
      >
        {t("amazingFeatures.cardOne.smallBox.title", {
          lng: currentLocale,
        })}
      </Typography>
      <Avatar
        src="/assets/icons/Profile_Picture.png"
        sx={{
          width: { md: "86px", sm: "72px", xs: "40px" },
          height: { md: "86px", sm: "72px", xs: "40px" },
          marginTop: "15px",
        }}
      />

      <Typography
        marginTop={3}
        fontSize={{ md: "30px", sm: "26px", xs: 20 }}
        fontWeight={700}
      >
        $50,000.00
      </Typography>
      <Stack
        direction={"row"}
        spacing={0.5}
        paddingBottom={3}
        alignItems={"center"}
      >
        <Typography
          fontSize={{ md: "14px", sm: "18px", xs: "12px" }}
          fontWeight={500}
          color={"#5E5E5E"}
        >
          {t("amazingFeatures.cardOne.smallBox.bodyline1", {
            lng: currentLocale,
          })}
        </Typography>
        <Typography
          fontSize={{ md: "14px", sm: "16px", xs: "12px" }}
          fontWeight={700}
        >
          {t("amazingFeatures.cardOne.smallBox.bodyline2", {
            lng: currentLocale,
          })}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default Feature1Box;
